<span  [style]="iconStyleString" [class]="iconClassName"></span>